import { useContext } from 'react'
import { PartnerDocumentContext } from 'egi/app/PartnersLine/views/PartnersLine'

const usePartnerDocumentation = () => useContext(PartnerDocumentContext)

export default usePartnerDocumentation
